import { render, staticRenderFns } from "./Pai.vue?vue&type=template&id=67fc4516&scoped=true&"
import script from "./Pai.vue?vue&type=script&lang=js&"
export * from "./Pai.vue?vue&type=script&lang=js&"
import style0 from "./Pai.vue?vue&type=style&index=0&id=67fc4516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fc4516",
  null
  
)

export default component.exports